import { useCallback, useEffect, useState } from "react";

import { PrecertFormField } from "src/pages/precert/types";
import { updateFieldAccordingly } from "src/helpers/precertForm";



const usePrecertComp = (formFields: PrecertFormField[]) => {
  const [formFieldsGroupedByGroupName, setFormFieldsGroupedByGroupName] = useState<{ [key: string]: PrecertFormField[] }>({})
  const [fieldNames, setFieldNames] = useState<{ [key: string]: string }>({})
  const [groupedFormFields, updateGroupedFormFields] = useState<{ [key: string]: { [key: string]: PrecertFormField } }>({});



  const processformFields = useCallback(() => {
    const tempFieldNames: { [key: string]: string } = {};
    let tempFormFields: PrecertFormField[] = [];

    formFields.forEach((field) => {
      const totalFields = updateFieldAccordingly(field, formFields)
      if (totalFields) tempFormFields = totalFields
    })

    const groupNames = tempFormFields.reduce((fieldsByGroup: { [key: string]: PrecertFormField[] }, field: PrecertFormField) => {
      tempFieldNames[field.name] = "";

      if (!fieldsByGroup[field.group]) fieldsByGroup[field.group] = [];
      fieldsByGroup[field.group].push(field);

      return fieldsByGroup;
    }, {})

    setFieldNames(tempFieldNames);
    setFormFieldsGroupedByGroupName(groupNames);
  }, [formFields]);

  useEffect(() => processformFields(), [processformFields]);



  const processGroupedPrecertFields = useCallback(() => {
    const groupNamesWithSortedInputs: { [key: string]: { [key: string]: PrecertFormField } } = {};

    Object.keys(formFieldsGroupedByGroupName).sort().forEach((group) => {
      if (!groupNamesWithSortedInputs[group]) groupNamesWithSortedInputs[group] = {};

      // formFieldsGroupedByGroupName[group].forEach((field) => {
      //   const totalFields = updateFieldAccordingly(field, formFieldsGroupedByGroupName[group])
      //   if (totalFields) formFieldsGroupedByGroupName[group] = totalFields
      // })

      formFieldsGroupedByGroupName[group].forEach((field) => {
        groupNamesWithSortedInputs[group][field.id] = field
      })
    })

    updateGroupedFormFields(groupNamesWithSortedInputs)
  }, [formFieldsGroupedByGroupName]);

  useEffect(() => {
    if (Object.keys(formFieldsGroupedByGroupName).length > 0) processGroupedPrecertFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processGroupedPrecertFields])



  return { fieldNames, groupedFormFields, updateGroupedFormFields };
}

export default usePrecertComp;
